/**
 * Shared AFAS debug-mode flag (session only, per community).
 * Used by Beheerder Afas-Koppeling toggle and Coordinator Synchronisatie debug column.
 */

export const afasDebugModeStorageKey = (communityId) =>
    `afas-koppeling-debug-mode:${communityId || 'unknown'}`;

export const readAfasDebugMode = (communityId) => {
    if (!communityId || typeof window === 'undefined') {
        return false;
    }

    try {
        return window.sessionStorage.getItem(afasDebugModeStorageKey(communityId)) === '1';
    } catch {
        return false;
    }
};

export const writeAfasDebugMode = (communityId, enabled) => {
    if (!communityId || typeof window === 'undefined') {
        return;
    }

    try {
        window.sessionStorage.setItem(
            afasDebugModeStorageKey(communityId),
            enabled ? '1' : '0',
        );
    } catch {
        // Ignore storage errors (private mode / quota).
    }
};
